import { create } from 'apisauce';
import { getAuthToken } from 'utils/cookies';

const token = getAuthToken();

const headers = {
  'Authorization': `Bearer ${token}`,
  'X-Requested-With': 'XMLHttpRequest',
};

const getImageInfo = async (params) => {
  const { header, filename, path, imageIsOriginal, originalKey, cropPosition } = params;
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/${path}`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const response = await api.post('', { header, filename, imageIsOriginal, originalKey, cropPosition });
  return response;
};

const getImageOriginalInfo = async (params) => {
  const { header, path, imageName, binaryOrig, hashcodeOrig, binary, hashcode, crop } = params;
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/${path}`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const response = await api.post('', { header, imageName, binaryOrig, hashcodeOrig, binary, hashcode, crop });
  return response;
};

const uploadImage = async (url, fields, file, params = {}) => {
  // eslint-disable-next-line
  const data = new FormData();
  const fieldLen = fields.length;
  let profileImageKey = null;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < fieldLen; ++i) {
    if (fields[i].name === 'key') profileImageKey = fields[i].value;
    data.append(fields[i].name, fields[i].value);
  }
  data.append('file', file);

  const api = create({
    baseURL: url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  const response = await api.post('', data, params);
  return { ...response, key: profileImageKey };
};

const imageProcess = async (params) => {
  const { key, method, path, body } = params;
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/${path}/${key}`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  let response;
  if (method === 'post') {
    response = await api.post('', { ...body });
    return response;
  }
  response = await api.get('', {});
  return response;
};

const getPresignedUrl = async (params) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/media-upload/form`,
    headers,
  });

  try {
    return await api.post('', params);
  } catch (e) {
    return {
      error: 'Could not get presigned url.',
    };
  }
};

const finalizeUpload = async (params) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/media-upload/finalize`,
    headers,
  });

  try {
    return await api.post('', params);
  } catch (e) {
    return {
      error: 'Could not finalize image upload.',
    };
  }
};

export {
  getImageInfo,
  uploadImage,
  imageProcess,
  getImageOriginalInfo,
  getPresignedUrl,
  finalizeUpload,
};
